export default {
  init: function() {
    if (!this.component) {
      return
    }

    this.addEventListenners()
  },

  addEventListenners: function() {
    this.searchBtn.addEventListener('click', this.handleCleanInput.bind(this))
  },

  handleCleanInput: function(e) {
    e.preventDefault()

    this.searchIpt.value = ''
  },

  component: document.querySelector('[data-component="main-search"]'),
  searchBtn: document.querySelector('[data-element="main-search__btn"]'),
  searchIpt: document.querySelector('[data-element="main-search__input"]')
}
